import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { apiClient, APIMessageResponse } from '@/shared/services/apiConfig';
import { PaginatedResponse } from '@/shared/types/responseTypes';
import {
  NotificationPreferenceOverrides,
  NotificationPreferenceItem,
} from '@/shared/types/notificationTypes';

const QUERY_KEY = ['notification-preferences'] as const;

export const useNotificationPreferences = (enabled: boolean = true) => {
  return useQuery({
    queryKey: QUERY_KEY,
    queryFn: async () => {
      const response = await apiClient.get<PaginatedResponse<NotificationPreferenceItem>>(
        '/api/v1/notification-preferences',
      );
      return response.data.results ?? [];
    },
    enabled,
  });
};

export const useUpdateNotificationPreferences = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (preferences: NotificationPreferenceOverrides) => {
      return await apiClient.put<APIMessageResponse>(
        '/api/v1/notification-preferences',
        { body: { preferences } },
      );
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: QUERY_KEY });
    },
  });
};